import React from 'react'
import { I18nContainer } from '../i18n-container'
import { RootContainer } from '../root-container'
import { AuthenticatedContainer } from '../authenticated-container'
import { ToastContainer } from '../toast-container'
import { ContextProvider, PostHogProvider } from '../../modules/context'

interface Props {
  children: React.ReactNode
}

export const Wrapper: React.FC<Props> = ({ children }) => {
  return (
    <I18nContainer>
      <PostHogProvider>
        <ContextProvider>
          <RootContainer>
            <AuthenticatedContainer>
              <>
                <ToastContainer />
                {children}
              </>
            </AuthenticatedContainer>
          </RootContainer>
        </ContextProvider>
      </PostHogProvider>
    </I18nContainer>
  )
}
